export default __webpack_public_path__ + "static/media/greg_wasserman.51b65b19.png";